import { render, staticRenderFns } from "./dictionaryIsDashboard.vue?vue&type=template&id=1a98ab85&scoped=true&"
import script from "./dictionaryIsDashboard.vue?vue&type=script&lang=js&"
export * from "./dictionaryIsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./dictionaryIsDashboard.vue?vue&type=style&index=0&id=1a98ab85&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98ab85",
  null
  
)

export default component.exports